module.exports = __webpack_public_path__ + "images/wechat/invitation-letter-57190eca250aee3adebf987a694ea0ba.png";